module.exports = __webpack_public_path__ + "media/react/assets/Feedback360MainIcon-9d0a55f13ad3cc32158fd97207b0af0e.svg";